import {
  EntityModel,
  SubscriptionPlanModuleId,
  SubscriptionInfoModel,
  UserRole,
} from "@jugl-web/rest-api";
import { createContext } from "react";
import { PlanLimitsReachedAlertProps } from "../../components/PlanLimitsReachedAlert";

export interface EntityContextValue {
  entityId: string | null;
  entity: EntityModel | null;
  role: UserRole | undefined;
  subscriptionInfo: SubscriptionInfoModel | null;
  refetchSubscriptionInfo: () => void;

  reinitialize: () => Promise<void>;
  isInitialized: boolean;
  isInitializationError: boolean;
  isVerifyBillingAlertVisible: boolean;
  showWriteRestrictedAlert: () => void;
  showPlanLimitsReachedAlert: (
    type: PlanLimitsReachedAlertProps["type"]
  ) => void;
  subscriptionRequiredAction: <T>(func: T) => T | (() => void);
  verifyBillingEmail: (entityId: string, email: string, otp?: string) => void;
  entitiesList: EntityModel[];
  isEntitiesLoading: boolean;
  isEntitiesFetching: boolean;

  isModuleAvailable: (
    moduleId: SubscriptionPlanModuleId | `${SubscriptionPlanModuleId}`
  ) => boolean;
  moduleRequiredAction: (
    moduleId: SubscriptionPlanModuleId | `${SubscriptionPlanModuleId}`,
    availableCallback?: () => void,
    unavailableCallback?: () => void
  ) => void;
}

export interface EntitySelectedContextValue extends EntityContextValue {
  entityId: string;
  entity: EntityModel;
  subscriptionInfo: SubscriptionInfoModel;
}

export const EntityContext = createContext<EntityContextValue | null>(null);
